import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledCard = styled.div`
  position: relative;
`

export const ImageWrapper = styled.div`
  border: 1px solid ${theme.token.var('colors.green.a50')};
  border-top-right-radius: ${theme.token.var('borderRadius.small')};
  border-top-left-radius: ${theme.token.var('borderRadius.small')};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${theme.token.var('colors.white')};
  height: 130px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: fill;
  }
`

export const CardSummary = styled.div<{ isBigger: boolean }>`
  background: ${theme.token.var('colors.green.a50')};
  padding: 11px 12px 20px 12px;
  border-bottom-left-radius: ${theme.token.var('borderRadius.small')};
  border-bottom-right-radius: ${theme.token.var('borderRadius.small')};
  min-height: ${({ isBigger }) => (isBigger ? '93px' : '79px')};
`
